// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import type { ComponentWithPrefetch } from '../../../types';

import Conflict from './Conflict';
import { Container } from './Container';
import PayerSelect from './PayerSelect';
import { ResellerOnlyAlert } from './ResellerOnlyAlert';

export type Props = {
  ownerMustReseller: boolean,
  failureCartOwners: boolean | number,
  onOwnerChange: (orgId: string) => void,
  frozen: boolean,
};

const InvoiceBlock = ({
  ownerMustReseller,
  onOwnerChange,
  failureCartOwners,
  frozen,
}: Props): React.MixedElement => {
  const { __ } = useTranslator();
  const conflict = failureCartOwners === 409;

  return (
    <>
      {ownerMustReseller && <ResellerOnlyAlert />}
      <Container title={__('Invoice this order to:')}>
        {conflict ? (
          <Conflict />
        ) : (
          <PayerSelect onOwnerChange={onOwnerChange} frozen={frozen} />
        )}
      </Container>
    </>
  );
};

// $FlowFixMe[invalid-exported-annotation]
InvoiceBlock.preFetch = PayerSelect.preFetch;

export default (InvoiceBlock: ComponentWithPrefetch<
  Props,
  typeof InvoiceBlock.preFetch,
>);
